import { encodeURIPath } from '@!/Util/string'

export const buildSearchUrl = (type, searchTerm, tabName) => {
  let url = `/store/search?type=${type}&search_term=${encodeURIPath(searchTerm)}`
  if (tabName) {
    url += `&tab_name=${tabName}`
  }
  return url
}
